<template>
  <div class="house-tax" style="width: 100vw">
    <SubCard :title="`${$t('house_for_rent')}`">
      <HouseForRent />
    </SubCard>
    <br />
    <SubCard :title="`${$t('house_not_for_rent')}`">
      <HouseNotForRent />
    </SubCard>
  </div>
</template>

<script>
import HouseForRent from "./houseForRent.vue";
import HouseNotForRent from "./houseNotForRent.vue";
import SubCard from "@/components/SubCard.vue";
export default {
  components: {
    HouseForRent,
    HouseNotForRent,
    SubCard,
  },
};
</script>
